export default function scrollDown() {
  // Scroll to the bottom of the chat
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: 'smooth', // Optional: Adds a smooth scroll animation
  });
}
